import {ValueObject} from '@s-ui/domain'

export class VehicleCertificationFeatureValueObject extends ValueObject {
  /**
   * @param {String} description
   * @param {String} iconUrl
   * @param {String} title
   * */
}
